<template>
  <div class="row revenuedata mb-1">
    <div class="col-6">
      <p class="chartDataLabel mb-2">{{labelLeft}}</p>
      <h5
        class="chartDataValue chartDataValueThis chartDataValuePlus"
        id="thisMonthAverageLabel"
      >
        {{currency}}{{valueLeft}}
      </h5>
    </div>
    <div class="col-6">
      <p class="chartDataLabel mb-2">{{labelRight}}</p>
      <h5 class="chartDataValue chartDataValueLast" id="lastMonthAverageLabel">
       {{currency}}{{valueRight}}
      </h5>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardRevenueData",
  props: [
    "labelLeft",
    "valueLeft",
    "labelRight",
    "valueRight",
    "currency",
  ],
  data() {
    return {};
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/dashboard/RevenueData.vue